import { IconClose } from "@/assets/icons";
import { Button } from "@/components/elements/Button";
import { IconBox } from "@/components/elements/IconBox";
import { background, black } from "@/theme/colors";
import { FCC } from "@/types/common";
import { Box, Modal as MuiModal, Stack, styled, Typography } from "@mui/material";
import { ReactNode } from "react";

export type TModalProps = {
  isOpen: boolean;
  title?: ReactNode;
  labelClose?: string;
  labelOk?: string;
  enableFooter?: boolean;
  enableCloseIcon?: boolean;
  hideBackdrop?: boolean;
  width?: number | string;
  height?: number | string;
  keepMounted?: boolean;
  preventCloseBackdrop?: boolean;
  disabledOk?: boolean;
  isLoadingOkBtn?: boolean;
  hiddenCloseBtn?: boolean;
  hiddenOkBtn?: boolean;
  flexDirectionBtnAction?: "row" | "row-reverse";
  justifyBtnAction?: "center" | "space-between";
  onOk?: () => void;
  onClose?: () => void;
};

export const Modal: FCC<TModalProps> = ({
  children,
  isOpen,
  title,
  labelClose,
  labelOk,
  isLoadingOkBtn,
  enableFooter = true,
  enableCloseIcon = true,
  hideBackdrop = false,
  keepMounted = false,
  width = 417,
  height,
  disabledOk = false,
  preventCloseBackdrop = false,
  justifyBtnAction = "center",
  flexDirectionBtnAction = "row",
  onOk,
  onClose,
  hiddenCloseBtn,
  hiddenOkBtn,
}) => {
  return (
    <MuiModal
      open={isOpen}
      hideBackdrop={hideBackdrop}
      onClose={!preventCloseBackdrop ? onClose : undefined}
      sx={{ position: hideBackdrop ? "relative" : "fixed", display: "flex", justifyContent: "center", alignItems: "center" }}
      keepMounted={keepMounted}
    >
      <ModalContainer width={width} height={height}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          {!title && <span></span>}
          {typeof title === "string" ? <Typography variant="head20Bold">{title}</Typography> : title}
          {enableCloseIcon && (
            <IconBox onClick={onClose} sx={{ p: 0 }}>
              <IconClose color={black[80]} fontSize={24} />
            </IconBox>
          )}
        </Stack>
        {children}
        {enableFooter && (
          <Stack flexDirection={flexDirectionBtnAction} justifyContent={justifyBtnAction} gap="24px">
            {!hiddenCloseBtn && (
              <Button size="sm" variant="ghost" onClick={onClose}>
                {labelClose || "いいえ"}
              </Button>
            )}
            {!hiddenOkBtn && (
              <Button isLoading={isLoadingOkBtn} size="sm" onClick={onOk} disabled={disabledOk}>
                {labelOk || "はい"}
              </Button>
            )}
          </Stack>
        )}
      </ModalContainer>
    </MuiModal>
  );
};

const ModalContainer = styled(Box)`
  min-width: 417px;
  overflow: auto;
  background-color: ${background.white};
  box-shadow: 0px 8px 24px 0px #00000026;
  border-radius: 8px;
  padding: 24px;
  max-height: 90vh;
  outline: none; /* Remove default focus outline */
  &:focus {
    outline: none;
  }
`;
